import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const taskLogEventRequest = createRequest(constants.taskLogEvent);
export const taskLogEventSuccess = createSuccess(constants.taskLogEvent);
export const taskLogEventFailure = createFailure(constants.taskLogEvent);

export const requestTaskLogEvent = taskLogEventRequest;
